// extracted by mini-css-extract-plugin
export var content = "_rj-1";
export var divider = "_rj-0";